// extracted by css-extract-rspack-plugin
export default {"title":"title-rz05ZX","pause_container":"pause_container-lI8D2f","pauseContainer":"pause_container-lI8D2f","row":"row-IKim4t"};